import _extends from "@babel/runtime/helpers/extends";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
/**
 * @jsxRuntime classic
 * @jsx jsx
 */

import { PureComponent } from 'react';
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { jsx } from '@emotion/react';
// eslint-disable-next-line @atlaskit/design-system/no-deprecated-imports
import { gridSize } from '@atlaskit/theme/constants';
import { contentStyles, taskStyles, decisionStyles, placeholderStyles } from './styles';
var Item = /*#__PURE__*/function (_PureComponent) {
  function Item() {
    _classCallCheck(this, Item);
    return _callSuper(this, Item, arguments);
  }
  _inherits(Item, _PureComponent);
  return _createClass(Item, [{
    key: "renderPlaceholder",
    value: function renderPlaceholder() {
      var _this$props = this.props,
        children = _this$props.children,
        placeholder = _this$props.placeholder,
        showPlaceholder = _this$props.showPlaceholder,
        itemType = _this$props.itemType;
      if (!showPlaceholder || !placeholder || children) {
        return null;
      }

      // TODO: Migrate away from gridSize
      // Recommendation: Replace gridSize with 8
      var offset = gridSize() * (itemType === 'TASK' ? 3 : 3.5);
      return jsx("span", {
        "data-testid": "task-decision-item-placeholder",
        "data-component": "placeholder"
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        ,
        css: placeholderStyles(offset),
        contentEditable: false
      }, placeholder);
    }
  }, {
    key: "renderMessageAppearance",
    value: function renderMessageAppearance() {
      var _this$props2 = this.props,
        contentRef = _this$props2.contentRef,
        children = _this$props2.children,
        icon = _this$props2.icon,
        itemType = _this$props2.itemType,
        checkBoxId = _this$props2.checkBoxId,
        dataAttributes = _this$props2.dataAttributes;
      if (itemType === 'TASK') {
        return (
          // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
          jsx("div", {
            css: taskStyles,
            id: "".concat(checkBoxId, "-wrapper")
          }, icon, this.renderPlaceholder(), jsx("div", _extends({
            "data-component": "content",
            css: contentStyles,
            ref: contentRef
          }, dataAttributes), children))
        );
      } else if (itemType === 'DECISION') {
        return jsx("div", {
          "data-testid": "elements-decision-item"
          // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
          ,
          css: decisionStyles(),
          "data-decision-wrapper": "true"
        }, icon, this.renderPlaceholder(), jsx("div", _extends({
          "data-component": "content",
          css: contentStyles,
          ref: contentRef
        }, dataAttributes), children));
      }
      return null;
    }
  }, {
    key: "render",
    value: function render() {
      return this.renderMessageAppearance();
    }
  }]);
}(PureComponent);
_defineProperty(Item, "defaultProps", {
  appearance: 'inline'
});
export { Item as default };